module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todos.length),
      expression: "todos.length"
    }],
    staticClass: "main"
  }, [_c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('ul', {
    staticClass: "todo-list"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.filteredTodos(_vm.todos)), function(todo) {
    return _c('li', {
      key: todo.id,
      staticClass: "todo",
      class: {
        completed: todo.completed, editing: todo == _vm.editedTodo
      }
    }, [_c('div', {
      staticClass: "view"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (todo.completed),
        expression: "todo.completed"
      }],
      staticClass: "toggle",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(todo.completed) ? _vm._i(todo.completed, null) > -1 : (todo.completed)
      },
      on: {
        "__c": function($event) {
          var $$a = todo.completed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (todo.completed = $$a.concat($$v))
            } else {
              $$i > -1 && (todo.completed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            todo.completed = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      on: {
        "click": function($event) {
          _vm.editTodo(todo)
        }
      }
    }, [_vm._v(_vm._s(todo.title))]), _vm._v(" "), _c('button', {
      staticClass: "destroy",
      on: {
        "click": function($event) {
          _vm.removeTodo(todo)
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (todo.title),
        expression: "todo.title"
      }, {
        name: "todo-focus",
        rawName: "v-todo-focus",
        value: (todo == _vm.editedTodo),
        expression: "todo == editedTodo"
      }],
      staticClass: "edit",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (todo.title)
      },
      on: {
        "blur": function($event) {
          _vm.doneEdit(todo)
        },
        "keyup": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.doneEdit(todo)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
          _vm.cancelEdit(todo)
        }],
        "input": function($event) {
          if ($event.target.composing) { return; }
          todo.title = $event.target.value
        }
      }
    })])
  }))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03dcb018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/todoList.vue
// module id = 30
// module chunks = 0